import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "./Header"; //import ProductChart from "../pages/charts/ProductChart";
// import { Switch } from "@progress/kendo-react-inputs";
import { Drawer, DrawerContent, DrawerItem, } from "@progress/kendo-react-layout";
import { GetSession, GetToken, GetUserId } from './Session';
import configData from "../config.json";
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';

const CustomItem = (props) => {
    const { visible, ...others } = props;
    const arrowDir = props["data-expanded"]
        ? "k-i-arrow-chevron-down"
        : "k-i-arrow-chevron-right";
    return (
        <React.Fragment>
            {props.visible === false ? null : (
                <DrawerItem {...others}>
                    <span className={"k-icon " + props.icon} />
                    <span className={"k-item-text"}>{props.text}</span>
                    {props["data-expanded"] !== undefined && (
                        <span
                            className={"k-icon " + arrowDir}
                            style={{
                                position: "absolute",
                                right: 10,
                            }}
                        />
                    )}
                </DrawerItem>
            )}
        </React.Fragment>
    );
};
export const DrawerContainer = (props) => {
    const [drawerExpanded, setDrawerExpanded] = React.useState(true);
    const [showDialog, setShowDialog] = React.useState(false);
    const selection = React.useRef();
    const navigate = useNavigate();
    const child = false
    const [items, setItems] = React.useState([
        { text: "Weighbridge", permission: "ViewWeighBridge", selected: false, route: "/Weighbridge", icon: "fa fa fa-solid fa-truck-moving", title: "Weighbridge", id: 1 },
        { text: "Dashboard", permission: "ViewBasicDashboard", selected: false, route: "/", icon: "fa fa fa-solid fa-gauge ", title: "Dashboard", id: 2 },
        { text: "Transactions", permission: "ViewTransactionsPage", selected: false, route: "/transactions", icon: "fa fa fa-solid fa-money-bill ", title: "Transactions", id: 3 },
        { text: "Trucks", permission: "ViewTruck", selected: false, route: "/trucks", icon: "fa fa fa-solid fa-truck ", title: "Trucks", id: 4 },
        { text: "EPA Report", permission: "ViewEPAReport", selected: false, route: "/EPAReport", icon: "fa fa fa-solid fa-gavel", title: "EPA Report", id: 5 },
        { text: "Customer", permission: "ViewCustomer", selected: false, route: "/customers", icon: "fa fa fa-solid fa-user-tie", title: "Customer", id: 6 },
        { text: "First Weighs", permission: "ViewFirstWeigh", selected: false, route: "/firstweighs", icon: "fa fa fa-solid fa-1 ", title: "First Weighs", id: 7 },
        { text: "Docket Lookup", permission: "ViewTransaction", selected: false, route: "/docketlookup", icon: "fa fa fa-solid fa-magnifying-glass ", title: "Docket Lookup", id: 8 },
        { text: "Jobs", permission: "ViewJob", selected: false, route: "/jobs", icon: "fa fa fa-solid fa-list-check ", title: "Jobs", id: 9 },


        { separator: true },
        // Group 2
        { text: "Products", permission: "ViewProductsGroup", selected: false, icon: "fa fa fa-solid fa-cart-flatbed", ["data-expanded"]: child, title: "Products", id: 100 },
        { text: "Waste Stream", permission: "ViewProductCategory", selected: false, route: "/wastestreams", icon: "fa fa fa-solid fa-recycle", title: "Waste Stream", id: 101, parentid: 100 },
        { text: "Product", permission: "ViewProduct", selected: false, route: "/products", icon: "fa fa fa-solid fa-boxes ", title: "Product", id: 102, parentid: 100 },
        { text: "Counted Product", permission: "ViewProduct", selected: false, route: "/countedItemProducts", icon: "fa fa fa-solid fa-calculator ", title: "Counted Product", id: 103, parentid: 100 },
        { text: "Source", permission: "ViewSource", selected: false, route: "/sources", icon: "fa fa fa-duotone fa-map-location-dot ", title: "Source", id: 104, parentid: 100 },
        { text: "Destination", permission: "ViewDestination", selected: false, route: "/destinations", icon: "fa fa fa-solid fa-map-location ", title: "Destination", id: 105, parentid: 100 },
        { text: "Inventory", permission: "ViewInventory", selected: false, route: "/inventory", icon: "fa fa fa-solid fa-warehouse ", title: "Inventory", id: 106, parentid: 100 },

        { separator: true },
        // Group 4
        { text: "Other Data", permission: "ViewOtherDataGroup", selected: false, icon: "fa fa fa-solid fa-bars ", ["data-expanded"]: child, title: "Other Data", id: 200 },
        { text: "Supplier", permission: "ViewCustomer", selected: false, route: "/suppliers", icon: "fa fa fa-solid fa-user-tag ", title: "Supplier", id: 201, parentid: 200 },
        { text: "Driver", permission: "ViewDriver", selected: false, route: "/drivers", icon: "fa fa fa-solid fa-id-card ", title: "Driver", id: 202, parentid: 200 },
        { text: "Visitors", permission: "ViewTransaction", selected: false, route: "/visitors", icon: "fa fa fa-solid fa-envelope ", title: "Messages", id: 203, parentid: 200 },
        { text: "Vehicle Type", permission: "ViewVehicleType", selected: false, route: "/vehicles", icon: "fa fa fa-solid fa-car ", title: "Vehicle Type", id: 204, parentid: 200 },
        { text: "Truck Configuration", permission: "ViewTruckConfiguration", selected: false, route: "/vehicleconfigurations", icon: "fa fa fa-duotone fa-trailer ", title: "Site", id: 205, parentid: 200 },
        { text: "Vouchers", permission: "ViewVouchers", selected: false, route: "/vouchers", icon: "fa fa fa-solid fa-barcode ", title: "Vouchers", id: 206, parentid: 200 },
        { text: "Messages", permission: "ViewMessageQueue", selected: false, route: "/messages", icon: "fa fa fa-solid fa-envelope ", title: "Messages", id: 207, parentid: 200 },
        { text: "Kiosk Playlists", permission: "ViewKioskPlaylists", selected: false, route: "/kioskplaylists", icon: "fa fa fa-solid fa-thumbs-up ", title: "Kiosk Playlists", id: 208, parentid: 200 },
        { text: "Inductions", permission: "ViewInductionPlaylists", selected: false, route: "/inductionplaylists", icon: "fa fa fa-solid fa-thumbs-up ", title: "Kiosk Playlists", id: 209, parentid: 200 },

        { separator: true },
        // Group 6
        { text: "Reports", permission: "ViewReportsGroup", selected: false, icon: "fa fa fa-solid fa-file ", ["data-expanded"]: child, title: "Reports", id: 300 },
        { text: "table Reports", permission: "ViewPivotTables", selected: false, route: "/reports", icon: "fa fa fa-solid fa-table ", title: "table Reports", id: 301, parentid: 300 },
        { text: "Simple Report", permission: "ViewSimpleReports", selected: false, route: "/SimpleReports", icon: "fa fa fa-regular fa-file ", title: "Simple Report", id: 302, parentid: 300 },

    { separator: true },
    // Group 7
        { text: "Settings", permission: "ViewSettingsGroup", selected: false, icon: "fa fa fa-solid fa-gear ", ["data-expanded"]: child, title: "Settings", id: 400 },
    { text: "Site", permission: "ViewSite", selected: false, route: "/sites", icon: "fa fa fa-solid fa-sitemap ", title: "Site", id: 401, parentid: 400 },
    { text: "Roles", permission: "ViewRole", selected: false, route: "/roles", icon: "fa fa fa-solid fa-users ", title: "Roles", id: 402, parentid: 400 },
    { text: "Operators", permission: "ViewUser", selected: false, route: "/users", icon: "fa fa fa-solid fa-user ", title: "Operators", id: 403, parentid: 400 },
    { text: "Change Password", permission: "ViewUser", selected: false, route: "/password", icon: "fa fa fa-solid fa-key ", title: "Change Password", id: 404, parentid: 400 },
    { text: "User Approval", permission: "ViewUserApproval", selected: false, route: "/userapproval", icon: "fa fa fa-solid fa-thumbs-up ", title: "User Approval", id: 405, parentid: 400 },
    { text: "Support Report", permission: "ViewSupport", selected: false, route: "/support", icon: "fa fa fa-solid fa-handshake-angle ", title: "Support Report", id: 406, parentid: 400 },
    { text: "Docket Templates", permission: "isAWSSupportRole", selected: false, route: "/dockets", icon: "fa fa fa-solid fa-receipt ", title: "Docket Templates", id: 407, parentid: 400 },
    { text: "User Interface", permission: "isAWSSupportRole", selected: false, route: "/managepages", icon: "fa fa fa-solid fa-users-gear ", title: "User Interface", id: 408, parentid: 400 },
    { text: "System Settings", permission: "isAWSSupportRole", selected: false, route: "/systemsetting", icon: "fa fa fa-solid fa-gear ", title: "System Settings", id: 409, parentid: 400 },
    { text: "Business Data", permission: "isAWSSupportRole", selected: false, route: "/businessdata", icon: "fa fa fa-solid fa-business-time ", title: "Business Data", id: 410, parentid: 400 },
    { text: "Output States", permission: "isAWSSupportRole", selected: false, route: "/outputstate", icon: "fa fa fa-solid fa-chess-rook ", title: "Output States", id: 411, parentid: 400 },
    { text: "Weighbridge Settings", permission: "isAWSSupportRole", selected: false, route: "/weighbridgesettings", icon: "fa fa fa-solid fa-screwdriver-wrench ", title: "Weighbridge Settings", id: 412, parentid: 400 },
        { text: "Manage View", permission: "isAWSSupportRole", selected: false, route: "/managepages", icon: "fa fa fa-solid fa-street-view ", title: "Manage View", id: 413, parentid: 400 },

        { separator: true },
        // Group 5
        { text: "Logs", permission: "ViewLogsGroup", selected: false, icon: "fa fa fa-solid fa-binoculars", ["data-expanded"]: child, title: "Logs", id: 500 },
        { text: "Event Log", permission: "ViewPrintEventLog", selected: false, route: "/eventlogs", icon: "fa fa fa-solid fa-eye ", title: "Event Log", id: 501, parentid: 500 },
        { text: "System Log", permission: "isAWSSupportRole", selected: false, route: "/systemlogs", icon: "fa fa fa-solid fa-gear ", title: "Event Log", id: 502, parentid: 500 },
        { text: "Offences", permission: "ViewOffence", selected: false, route: "/offences", icon: "fa fa fa-solid fa-xmark", title: "Offences", id: 503, parentid: 500 },

        { separator: true },
        // Group 6
        { text: "Training", permission: "ViewTraining", selected: false, icon: "fa fa fa-solid fa-graduation-cap", ["data-expanded"]: child , title: "Online Training", id: 600 },
        { text: "User Manual", permission: "ViewTraining", selected: false, route: "/usermanual", icon: "fa fa fa-solid fa-book ", title: "Online Training", id: 601, parentid: 600 },
        { text: "Software Training", permission: "ViewTraining", selected: false, route: "/SoftwareTraining", icon: "fa fa fa-solid fa-chalkboard ", title: "Online Training", id: 602, parentid: 600 },
        { text: "Online Modules", permission: "ViewTraining", selected: false, route: "/videotraining", icon: "fa fa fa-solid fa-chalkboard ", title: "Online Training", id: 603, parentid: 600 },
    ]);
    const [expanded, setExpanded] = React.useState(false);
    const data = items.map((item) => {
        const { parentid, ...others } = item;
        if (parentid !== undefined) {
            const par = items.find((p) => p.id === parentid);
            if (par !== undefined) {
                return {
                    ...others,
                    visible: par["data-expanded"],
                };
            }
        }
        return item;
    });

    const CheckPermission = (p, t) => {
        return p.find(obj => obj === t) === t;
    }

    React.useEffect(() => {
        var url = `${configData.SERVER_URL}apiv7/options?userId=${GetUserId()}`;
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        fetch(url, init).then(response => response.json()).then(d => {
            let newItems = [];
            let isLocal = d.isLocal;
            if (GetSession().SiteID === 1) isLocal = false;
            for (let i = 0; i < items.length; i++) {
                if ((!isLocal && items[i].text !== "Weighbridge") || (isLocal && items[i].text !== "Site")) {
                    if (CheckPermission(d.permissions, items[i].permission) || items[i].separator) newItems.push(items[i]);
                }
            }
            setItems(newItems);
        });
    }, [])

    // const [position, setPosition] = React.useState(true);

    // let positionMode = position ? "start" : "end";

    const handleClick = () => {
        setDrawerExpanded(!drawerExpanded);
    };

    const onSelect = (ev) => {
        let inUse = localStorage.getItem("WBInUse");
        if (window.location.pathname.toLowerCase().indexOf("weighbridge") > 0 && !window.location.pathname.toLowerCase().indexOf("weighbridgese") > 0 && inUse === "true") {
            selection.current = ev;
            setShowDialog(true);
            return;
        }
        if (!window.location.pathname.toLowerCase().indexOf("weighbridge") > 0 || window.location.pathname.toLowerCase().indexOf("weighbridgese") > 0) localStorage.setItem("WBInUse", "false");
        selection.current = undefined;
        menuSelect(ev);
    }

    const continueSelection = (ev) => {
        setShowDialog(false);
        menuSelect(selection.current);
    }

    const menuSelect = (ev) => {
        const currentItem = ev.itemTarget.props;
        if (currentItem["data-expanded"] === undefined) { setDrawerExpanded(false); }
        const isParent = currentItem["data-expanded"] !== undefined;
        const nextExpanded = !currentItem["data-expanded"];
        const newData = items.map((item) => {
            const {
                selected,
                ["data-expanded"]: currentExpanded,
                id,
                ...others
            } = item;
            const isCurrentItem = currentItem.id === id;
            return {
                selected: isCurrentItem,
                ["data-expanded"]:
                    isCurrentItem && isParent ? nextExpanded : currentExpanded,
                id,
                ...others,
            };
        });
        //props.history.push(ev.itemTarget.props.route);
        setItems(newData);
        navigate(ev.itemTarget.props.route);
        setExpanded(false);
    };

    // const handleChange = () => {
    //   setPosition((prevState) => !prevState);
    // };




    return (
        <div>
            <Header onButtonClick={handleClick} />
            <Drawer
                expanded={drawerExpanded}
                mode="push"
                width={180}
                items={data}
                onSelect={onSelect}
                mini={false}
                item={CustomItem}
                mouseenter={onSelect}
            >
                <DrawerContent>{props.children}</DrawerContent>
            </Drawer>
            {showDialog && (<Dialog title={'Please confirm'} onClose={() => setShowDialog(false)}>
                <p style={{ margin: '25px', textAlign: 'center' }}>Are you sure you want to continue?</p>
                <DialogActionsBar>
                    <Button type="button" onClick={() => setShowDialog(false)}>
                        No
                    </Button>
                    <Button type="button" onClick={continueSelection}>
                        Yes
                    </Button>
                </DialogActionsBar>
            </Dialog>)}
        </div>
    );
};

export default DrawerContainer;
